module.exports = __webpack_public_path__ + "static/img/12.ab4a34f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/zh/12.png
// module id = VjPJ
// module chunks = 0